import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { WarningAmber, DeleteOutline, InfoOutlined } from '@mui/icons-material';
import { tokens } from '../../theme';

const SEVERITY_CONFIG = {
  danger: {
    icon: <DeleteOutline />,
    iconColor: tokens.color.semantic.error,
    iconBg: tokens.color.status.offline.bg,
    confirmLabel: 'Confirmar',
    confirmColor: 'error',
  },
  warning: {
    icon: <WarningAmber />,
    iconColor: tokens.color.semantic.warning,
    iconBg: tokens.color.status.suspended.bg,
    confirmLabel: 'Continuar',
    confirmColor: 'warning',
  },
  info: {
    icon: <InfoOutlined />,
    iconColor: tokens.color.semantic.info,
    iconBg: '#EFF6FF',
    confirmLabel: 'Aceptar',
    confirmColor: 'primary',
  },
};

const ConfirmDialog = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  severity = 'warning',
  confirmLabel,
  loading = false,
}) => {
  const cfg = SEVERITY_CONFIG[severity] || SEVERITY_CONFIG.warning;
  const label = confirmLabel || cfg.confirmLabel;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: tokens.radius.md,
              backgroundColor: cfg.iconBg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: cfg.iconColor,
              flexShrink: 0,
              '& .MuiSvgIcon-root': { fontSize: 20 },
            }}
          >
            {cfg.icon}
          </Box>
          {title}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: tokens.color.ink.secondary, lineHeight: 1.6 }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color={cfg.confirmColor}
          onClick={onConfirm}
          disabled={loading}
        >
          {label}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
